const getBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '') + '/api';
  }
  return 'http://localhost:4000/api';
};

export const urls = getBaseUrl();

export const Request = async (url, method = 'GET', body) => {
  const headers = {
    Accept: 'application/json',
  };

  const hasBody = body !== undefined && body !== null;
  if (hasBody) headers['Content-Type'] = 'application/json';

  try {
    let token = localStorage.getItem('token');
    if (!token) {
      const userRaw = localStorage.getItem('user');
      if (userRaw) {
        const user = JSON.parse(userRaw);
        token = user.token;
      }
    }
    if (token && token !== 'undefined' && token !== 'null') {
      headers['Authorization'] = `Bearer ${token}`;
    }
  } catch {
    // ignore
  }

  const options = {
    method,
    headers,
  };
  if (hasBody) options.body = JSON.stringify(body);

  const res = await fetch(urls + url, options);

  let payload = null;
  try {
    payload = await res.json();
  } catch (_ignored) {
    // ignore
  }

  if (!res.ok) {
    if (res.status === 401) {
      try {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      } catch {
        // ignore
      }
    }
    const msg = (payload && (payload.message || payload.error)) || `Request failed (${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    err.payload = payload;
    throw err;
  }

  return payload;
};